import React, {Component} from 'react'
import CustomTable from '../../../../../elements/Table/CustomTable'
import {Button} from 'antd'
import {get, isEmpty, round, sum} from 'lodash'
import {moneyColumn, numVal} from '../../../../../modules/Utils'

class BudgetLines extends Component {
  render() {
    let columns = [
      {
        Header: 'ID',
        accessor: '_key',
        Cell: ({value, original}) => (
          <a onClick={e => this.props.onShowEditBudget(e, original)}>
            {value || original.key}
          </a>
        ),
      },
      {
        Header: 'Target',
        accessor: 'target',
        Cell: ({value}) => moneyColumn(numVal({value}, 'value')),
        Footer: (
          <strong>
            {moneyColumn(
              round(sum(this.props.budgetsList.map(d => numVal(d, 'target')))),
            )}
          </strong>
        ),
      },
      {
        Header: 'Account',
        accessor: 'account._id',
      },
    ]
    const {
      type,
      budgetsList,
      fetchLines,
      fetchingLines,
      onShowBudget,
      actions,
      visibleAddLine,
    } = this.props
    const isUpdatable =
      type === 'new' || !!actions.find(a => a.key === 'update')
    if (!isUpdatable) {
      columns = columns.filter(c => c.accessor !== 'key')
    }
    return (
      <CustomTable
        columns={columns}
        data={budgetsList}
        loading={fetchingLines}
        hide={{refresh: type === 'new', create: !isUpdatable}}
        fetch={fetchLines}
        CreateButton={() => (
          <Button
            type={'primary'}
            size={'small'}
            icon={'plus'}
            // disabled={!isUpdatable || !visibleAddLine}
            onClick={onShowBudget}>
            New{' '}
          </Button>
        )}
      />
    )
  }
}

BudgetLines.propTypes = {}
BudgetLines.defaultProps = {}

export default BudgetLines
